import type { ValuePropsFeaturedImageKey } from "./types";
import { valuePropImagePath } from "./imagePath";

export interface ValuePropFeaturedImage {
  src: string;
  alt: string;
  width: number;
  height: number;
}

export const VALUE_PROP_FEATURED_IMAGES: Record<
  ValuePropsFeaturedImageKey,
  ValuePropFeaturedImage
> = {
  "mobile-rays-lifestyle": {
    src: `${valuePropImagePath}mobile-rays-lifestyle.jpg`,
    alt: "Person using Xfinity Mobile on couch near bright windowsill",
    width: 1600,
    height: 1067,
  },
  "stream-lifestyle": {
    src: `${valuePropImagePath}stream-lifestyle.jpg`,
    alt: "Friends watching live TV together on couch",
    width: 1600,
    height: 1067,
  },
};
